import { CustomerAccountSideMenuProps } from '../types';
import { CatSideMenu } from '@blocks-react/components/SideMenu';
import styles from '../customer-account.module.scss';

export const CustomerAccountSideMenu = ({
  classname,
  children
}: CustomerAccountSideMenuProps) => {
  return (
    <div className={classname}>
      <CatSideMenu className={styles['customer-account__side-menu--no-border']}>
        {children}
      </CatSideMenu>
    </div>
  );
};
